import styled from 'styled-components';

import { BlockContainer, FullWidthListContainer, IndentContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { wideBreakpoints } from '../wideContainer';


export const Wrapper = styled(FullWidthListContainer)`
    padding: 24px;
    background-color: ${COLORS.ButtonPrimary};
`;

export const SIndentContainer = styled(IndentContainer)`
    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding-bottom: 16px;
    }
    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-bottom: 0;
    }
`;

export const MessageBody = styled(BlockContainer)`
    max-width: 700px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        max-width: 600px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        max-width: 528px;
    }
`;

export const MessageTailContainer = styled(NonStaticContainer)`
    transform: rotateY(180deg);

    @media (max-width: ${wideBreakpoints.mobile}) {
        & > svg {
            width: 19px;
            height: 29px;
        }
    }
`;

export const ImageWrapper = styled.div`
    width: 276px;
    height: 228px;
    align-self: flex-end;

    img, picture {
        display: block;
        height: auto;
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 230px;
        height: 190px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 170px;
        height: 140px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: none;
    }
`;

export const MobileImageWrapper = styled(ImageWrapper)`
    display: none;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        width: calc(100% + 24px);
        height: auto;
        margin: 0 -24px -24px 0;
        position: relative;
        right: -24px;
        bottom: 0;
    }
`;
